import React, { useState } from 'react'
import GenericModal from '../../../../components/modal/GenericModal';
import InputText from '../../../../components/modalComponents/InputText';
import InputTextArea from '../../../../components/modalComponents/InputTextArea';

// ──────────────────────────────────────────────────────────────────────────
// Modal chico "Nueva declaración" / "Editar declaración" (paso 3, boceto
// "Boceto_fichas_1_y_2... paso 3" compartido por Jody). Se abre desde
// DeclaracionesStep.jsx tanto para crear como para editar — si llega
// `declaracion` en los datos, precarga Título/Detalle y cambia el botón a
// "Guardar"; si no, arranca vacío con el botón "Agregar" tal como el boceto.
//
// Sin backend todavía: `onSave` es un callback local que le devuelve el
// objeto {Titulo, Detalle} al state de DeclaracionesStep — cuando exista el
// API real (guardar TP_ConvocatoriaDeclaracion) esto pasa a un submitForm.
// ──────────────────────────────────────────────────────────────────────────
const DeclaracionFormModal = ({ toggleModal, declaracion, onSave }) => {
    const isEditing = !!declaracion;
    const [formValues, setFormValues] = useState({ Titulo: declaracion?.Titulo ?? "", Detalle: declaracion?.Detalle ?? "" });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues(lastData => ({ ...lastData, [name]: value }));
    }

    const handleSubmit = () => {
        if (!formValues.Titulo?.trim()) return;
        onSave({ ...declaracion, ...formValues });
        toggleModal();
    }

    return (
        <GenericModal showModal={toggleModal} titulo={isEditing ? "Editar declaración" : "Nueva declaración"} width="600px">
            <div className="modal-body">
                <InputText label="Declaración (Título)" name="Titulo"
                    value={formValues.Titulo}
                    onChange={handleChange}
                    direction="column" isRequired />

                <InputTextArea label="Detalle" name="Detalle"
                    value={formValues.Detalle}
                    onChange={handleChange}
                    direction="column" rows={6} />

                <div className="d-flex justify-content-center mt-3">
                    <button type="button" className="btn generic-button-buscador generic-button-hover-verde green-innova-background" onClick={handleSubmit}>
                        {isEditing ? "Guardar" : "Agregar"}
                    </button>
                </div>
            </div>
        </GenericModal>
    )
}

export default DeclaracionFormModal
